module.exports = __webpack_public_path__ + "static/contact-hero-8dc4fa0477ba53f1fd1e43ea19a24fda.png";